import React from 'react';
import ChileOfferShoppingCart from '@fingo/lib/components/shopping/OfferShoppingCart/ChileOfferShoppingCart';
import { availableOffersTitles } from '@fingo/lib/constants/factoring/summary-titles';
import CHILE_OFFER_FLOW_STEP_IDS from '@fingo/lib/constants/factoring/chile-offer-flow-step-ids';
import { HEADERS, CLIENT_HEADERS, MOBILE_HEADERS } from './available-offers';

const BCHOfferShoppingCart = (props) => (
  <ChileOfferShoppingCart {...props} requireBankAccount={false} />
);

const getRowConstraintValue = (row) => row?.dteType?.id;

const getStepsConditions = ({
  offerIds,
  showConfirmationSummary,
  showCessionStep,
  cessionStepperNavigation,
}) => [
  offerIds.length === 0,
  showConfirmationSummary,
  showCessionStep,
  cessionStepperNavigation?.stepId === CHILE_OFFER_FLOW_STEP_IDS.CESSION_TYPE_SELECTOR,
  cessionStepperNavigation?.currentStep > 1,
];

const OPTIONS = {
  summaryDataInfo: availableOffersTitles.summaryDataInfoChile,
  headers: HEADERS,
  mobileHeaders: MOBILE_HEADERS,
  clientHeaders: CLIENT_HEADERS,
  summaryActionButtonText: availableOffersTitles.summaryActionButtonTextChile,
  ShoppingCartComponent: BCHOfferShoppingCart,
  showInformationStack: true,
  useSelectDaysButtons: true,
  minDaysFromToday: 10,
  disabledRowTooltip: () => 'Solo puedes seleccionar facturas del mismo tipo de documento',
  getRowConstraintValue,
  getStepsConditions,
};

export default OPTIONS;
